import { render, staticRenderFns } from "./card_hist.vue?vue&type=template&id=27ee9d8d&scoped=true&"
import script from "./card_hist.vue?vue&type=script&lang=js&"
export * from "./card_hist.vue?vue&type=script&lang=js&"
import style0 from "./card_hist.vue?vue&type=style&index=0&id=27ee9d8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee9d8d",
  null
  
)

export default component.exports